module.exports = __webpack_public_path__ + "img/name_signaturesize.1298bc1f.png";